/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=HelpDialog&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=HelpDialog&lang=js"

import "./index.vue?vue&type=style&index=0&id=ff4a7fc2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff4a7fc2"]])

export default __exports__